module.exports = global.config = {
    isProduction: false,
    CameraStart: false,
    isChangeCamera: false,
    cameraId: ""
};